<template>
  <div class="selected-data-cell">
    <CustomCheckbox
      color="cold-marine"
      :value="value"
      size="s"
      @input="value = !value"
    />
  </div>
</template>

<script>
import CustomCheckbox from '@/components/common/CustomCheckbox.vue';

export default {
  name: 'SelectedEmployeeTableCell',
  components: {
    CustomCheckbox,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
    selectedEmployees: {
      type: Array,
      required: true,
      default: () => [],
    },
    excludedEmployees: {
      type: Array,
      required: true,
      default: () => [],
    },
    isAllSelected: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    value: {
      // eslint-disable-next-line no-unused-vars
      set(value) {
        this.$emit('checked', this.item);
      },
      get() {
        return this.selectedEmployees.includes(this.item.email) ||
          (this.isAllSelected && this.item?.selected !== undefined && this.item.selected && !this.excludedEmployees.includes(this.item.email)) ||
          (this.isAllSelected && this.item?.selected === undefined && !this.excludedEmployees.includes(this.item.email));
      },
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/assets/styles/design-system';
.selected-data-cell{
  margin-top: rem(19);
}
</style>
